import React, { useState, useEffect } from 'react';
import io from 'socket.io-client';
import './App.css';

// Connect to the Flask backend WebSocket
const socket = io('http://127.0.0.1:5000');

function App() {
  const [text, setText] = useState('');
  const [receivedText, setReceivedText] = useState('No data received yet.');
  const [isListening, setIsListening] = useState(false);
  const [audioUrl, setAudioUrl] = useState('');

  // Handle text input change
  const handleInputChange = (e) => {
    setText(e.target.value);
  };

  // Handle form submission (transmit text)
  const handleTransmit = async (e) => {
    e.preventDefault();
    if (!text) return;

    try {
      const response = await fetch('http://127.0.0.1:5000/transmit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ text }),
      });
      const data = await response.json();
      if (data.audio_url) {
        setAudioUrl(data.audio_url); // Update the audio URL
      }
      console.log(data.message);
    } catch (error) {
      console.error('Error transmitting text:', error);
    }
  };

  // Handle start/stop listening
  const toggleListening = async () => {
    if (isListening) {
      setIsListening(false);
      // Stop listening (optional: send a request to the backend)
    } else {
      setIsListening(true);
      try {
        const response = await fetch('http://127.0.0.1:5000/listen', {
          method: 'POST',
        });
        const data = await response.json();
        console.log(data.message);
      } catch (error) {
        console.error('Error starting listening:', error);
      }
    }
  };

  // Listen for incoming messages from the backend
  useEffect(() => {
    socket.on('receive_text', (data) => {
      setReceivedText(data.text);
    });

    // Clean up the socket connection
    return () => {
      socket.disconnect();
    };
  }, []);

  return (
    <div className="App">
      <h1>GibberLink Communication</h1>
      <form onSubmit={handleTransmit}>
        <label htmlFor="text-input">Enter text to transmit:</label>
        <input
          id="text-input"
          type="text"
          value={text}
          onChange={handleInputChange}
          required
        />
        <button type="submit">Transmit</button>
      </form>

      <button onClick={toggleListening}>
        {isListening ? 'Stop Listening' : 'Start Listening'}
      </button>

      <h2>Received Text:</h2>
      <div id="received-text">{receivedText}</div>

      {/* Audio player and download button */}
      {audioUrl && (
        <div>
          <h2>Generated Audio:</h2>
          <audio controls src={`http://127.0.0.1:5000${audioUrl}`}>
            Your browser does not support the audio element.
          </audio>
          <br />
          <a
            href={`http://127.0.0.1:5000${audioUrl}`}
            download="gibberlink_audio.wav"
            style={{ textDecoration: 'none' }}
          >
            <button>Download Audio</button>
          </a>
        </div>
      )}
    </div>
  );
}

export default App;